import React from 'react';

/**
 * Profile page icon SVG
 */
function ProfileNavIcon() {
  return (
    <svg
      version="1.1"
      xmlns="https://www.w3.org/2000/svg"
      x="0px"
      y="0px"
      viewBox="0 0 602.6 629.5"
      className="c-icon-nav-size-24"
    >
      <g>
        <path
          className="c-icon-nav-path"
          d="M29.2,628.3c-3.7,0-7.4-0.7-11-2.2c-14.3-6.1-21-22.6-15-36.9c51-120.7,161.7-192.7,296-192.7c128,0,246,74.8,300.7,190.6c6.6,14.1,0.6,30.8-13.4,37.5c-14,6.6-30.8,0.6-37.5-13.4c-45.4-96.2-143.4-158.4-249.8-158.4c-112.6,0-201.6,57.7-244.1,158.4C50.6,621.8,40.1,628.3,29.2,628.3z"
        />
        <path
          className="c-icon-nav-path"
          d="M303.2,368c-101.4,0-183.9-82.5-183.9-183.9S201.7,0.1,303.2,0.1s183.9,82.5,183.9,183.9S404.6,368,303.2,368zM303.2,56.4c-70.4,0-127.6,57.3-127.6,127.6c0,70.4,57.3,127.6,127.6,127.6c70.4,0,127.6-57.3,127.6-127.6C430.8,113.7,373.6,56.4,303.2,56.4z"
        />
      </g>
    </svg>);
}

export default ProfileNavIcon;



// WEBPACK FOOTER //
// ./src/layout/graphics/NavIcons/ProfileNavIcon.js